<template>
  <div class="register columns">
    <!-- 没有设置背景图的情况下的背景轮播图 -->
    <div class="bgpics">
      <transition-group tag="ul" name="img" mode="out-in">
        <li v-for="(image,index) in imgs" :key="image" v-show="index===mark">
          <div class="divImg" :style="{backgroundImage: 'url('+image+')'}"></div>
        </li>
      </transition-group>
    </div>

    <div class="row">
      <div class="register_box row" v-bind:class="flag==true?'fadeinleft':'fadeinright'">
        <div class="rbox_l column">
          <div class="rbox_imgbox" :style="{backgroundImage: 'url('+maxlogo+')'}"></div>
          <div id="map"></div>
          <p>欢迎使用{{system}}</p>
        </div>
        <div class="rbox_r">
          <h1>{{login_msg}}</h1>
          <el-form
            :model="ruleForm2"
            status-icon
            :rules="rules2"
            ref="ruleForm2"
            class="demo-ruleForm"
          >
            <el-form-item prop="user" :error="erroruser">
              <el-input placeholder="用户名或手机号" v-model="ruleForm2.user" auto-complete="off">
                <img src="../assets/login/yonghu.png" alt slot="prefix" />
              </el-input>
            </el-form-item>

            <el-form-item prop="psd" :error="errorpsd">
              <el-input
                placeholder="密码"
                v-model="ruleForm2.psd"
                type="password"
                auto-complete="off"
              >
                <i slot="prefix">
                  <img src="../assets/login/mima.png" alt />
                </i>
              </el-input>
            </el-form-item>

            <el-form-item>
              <el-button
                type="primary"
                class="btn_login"
                @click="submitForm('ruleForm2')"
                @keyup.enter.native="submitForm('ruleForm2')"
              >登录</el-button>
            </el-form-item>
          </el-form>

          <div class="forget_box row">
            <el-checkbox label="记住用户名" name="type"></el-checkbox>
            <div class="box_r row">
              <router-link to="/password">
              <span>忘记密码</span>
              </router-link>
              <div class="line"></div>
              <router-link to="/register">
                <span>注册</span>
              </router-link>
            </div>
          </div>
          <div class="other_box row">
            <span>第三方登录</span>
            <!---去掉qq登录--20220825-del-zjl--->
            <!-- <img
              :src="qqimg"
              alt
              @mouseover="changeimg(1)"
              @mouseout="moveimg(1)"
              id="qq"
              @click="qqlogin"
            /> -->
            <img :src="wximg" alt @mouseover="changeimg(2)" @mouseout="moveimg(2)" @click="wxshow" />
            <!-- <img :src="weibo" alt @mouseover="changeimg(3)" @mouseout="moveimg(3)" /> -->
          </div>
        </div>
      </div>
      <!-- 微信二维码部分 -->
      <transition name="wx">
        <div class="wx_code rows" v-if="flag">
          <img :src="wxcode" alt />
        </div>
      </transition>
    </div>

    <!-- 版权部分 -->
    <div class="copy_box rows">
      <span>ISO20000信息技术服务管理体系认证</span>
      <span>|</span>
      <span>ISO27001信息安全管理体系认证</span>
      <span>|</span>
      <span>{{copyright}}</span>
      <span><a href="https://beian.miit.gov.cn">鄂ICP备2020015604号-2</a></span>
      <span style="margin-left:10px">|</span>
      <span>技术支持：400-000-7168</span>
      <div class="demo-image__preview">
          <el-image style="width: 30px; height: 30px; display: block !important;" :src="url" @mouseover="enterShow">
          </el-image>
      </div>
      <div>
          <el-image :style="{right:(screenWidth < 0 ? 0 : screenWidth) + 'px'}" :src="url" class="big-img" v-show="isHow"  @mouseout="enterHide">
          </el-image>
      </div>
    </div>
  </div>
</template>

<style>
.big-img{
  width: 300px; 
  height: 300px;
  margin-bottom: 0px;
  z-index: 999999;
  position: absolute;
  bottom: -5px;
  /* right: 2rem; */
  /* right: 16%; */
}
.wx-enter,
.wx-leave-to {
  opacity: 0;
  transform: translateX(-2rem);
}
.wx-enter-active,
.wx-leave-active {
  transition: all 0.5s ease;
}

.fadeinleft {
  opacity: 1;
  transform: translateX(-0.5rem);
  transition: all 1s ease;
}

.fadeinright {
  opacity: 1;
  transition: all 1s ease;
}

.register {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  z-index: -10;
  /*是背景不要重复  */
  background-repeat: no-repeat;
  /* 让图片随屏幕大小同步缩放，但是有部分可能会被裁切，不过不至于会露白，下面两句是为chrome和opera浏览器作兼容。 */
  background-size: 100% 100%;
  -webkit-background-size: cover;
  -o-background-size: cover;
  background-position: 0 center;
}
.register_box {
  width: 8.4rem;
  height: 4.5rem;
  position: relative;
}
.rbox_l {
  width: 3.26rem;
  height: 4.5rem;
  background-color: rgba(67, 148, 208, 0.8);
  box-shadow: -0.03rem 0 0.09rem 0 rgba(36, 32, 32, 1);
  border-radius: 0.08rem 0 0 0.08rem;
  align-items: center;
}
.rbox_imgbox {
  width: 1.93rem;
  height: 0.35rem;
  margin-top: 0.77rem;
  overflow: hidden;
  background-origin: content; /*从content区域开始显示背景*/
  background-position: 50% 50%; /*图片上下左右居中*/
  background-size: contain; /*保持图像本身的宽高比例，将图片缩放到宽度或高度正好适应定义背景的区域*/
  background-repeat: no-repeat;
  /* -webkit-filter: brightness(0) invert(1);
  filter: brightness(0) invert(1); */
}
.rbox_l p {
  font-size: 0.14rem;
  color: rgba(255, 255, 255, 1);
  margin-bottom: 0.05rem;
}
#map {
  width: 3.14rem;
  height: 3.14rem;
  background: transparent;
}
.rbox_r {
  width: 5.14rem;
  height: 4.5rem;
  background: rgba(255, 255, 255, 1);
  box-shadow: -0.03rem 0 0.09rem 0 rgba(36, 32, 32, 1);
  border-radius: 0 0.08rem 0.08rem 0;
}
.rbox_r h1 {
  font-size: 0.18rem;
  font-family: MicrosoftYaHei-Bold;
  font-weight: bold;
  color: rgba(67, 148, 208, 1);
  margin-left: 0.63rem;
  margin-top: 0.49rem;
  margin-bottom: 0.25rem;
}
.register .el-form-item__content {
  margin-left: 0.63rem !important;
  width: 3.88rem;
  margin-top: 0.1rem;
}
.register .el-form-item {
  margin-bottom: 0.14rem;
}
.btn_login {
  width: 3.88rem;
  height: 0.42rem;
  margin-top: 0.05rem;
}
.register .el-input__prefix img {
  width: 0.15rem;
  height: 0.17rem;
  margin-bottom: 0.03rem;
}
.register .el-input__prefix {
  width: 0.44rem;
  height: 0.25rem;
  margin-top: 0.08rem;
  border-right: 0.01rem solid #dcdfe6;
}
.register .el-input--prefix .el-input__inner {
  padding-left: 0.6rem;
}
.forget_box {
  width: 3.88rem;
  margin-left: 0.63rem;
  justify-content: space-between;
  margin-top: 0.05rem;
}
.box_r {
  width: 1.1rem;
  height: 0.2rem;
  font-size: 0.14rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  justify-content: space-between;
}
.box_r .line {
  width: 0.01rem;
  height: 0.13rem;
  background-color: rgba(153, 153, 153, 1);
  margin-top: 0.04rem;
}
.box_r span {
  cursor: pointer;
}
.box_r a {
  text-decoration: none;
  cursor: pointer;
  color: rgba(153, 153, 153, 1);
}
.box_r span:hover {
  color: #409eff;
}
.other_box {
  width: 3.88rem;
  margin-left: 0.63rem;
  margin-top: 0.38rem;
  align-items: center;
  justify-content: flex-start;
  font-size: 0.14rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(136, 136, 136, 1);
}
.other_box img {
  width: 0.39rem;
  height: 0.39rem;
  margin-left: 0.1rem;
  cursor: pointer;
}
.wx_code {
  width: 4.5rem;
  height: 4.5rem;
  margin-left: 0.2rem;
  background-color: #fff;
  border-radius: 0.08rem;
  z-index: 99;
}
.el-message {
  font-size: 16px;
}
.bgpics {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
.bgpics ul,
.bgpics ul li {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  list-style: none;
  overflow: hidden;
}
.bgpics ul li {
  position: absolute;
}

.bgpics .divImg {
  background-position: 0px;
  background-size: cover;
  background-repeat: no-repeat;
  width: 100%;
  height: 100%;
}
.img-enter-active,
.img-leave-active {
  transition: all 5s ease;
}
.img-enter,
.img-leave-to {
  opacity: 0;
  transform: scale(1.06);
}
.img-enter-to,
.img-leave {
  opacity: 1;
}
.copy_box {
  width: 100%;
  height: 20px;
  position: absolute;
  bottom: 50px;
  left: 0;
}
.copy_box span {
  font-size: 12px;
  padding-right: 10px;
}
</style>


<script>
export default {
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入用户名"));
      } else {
        // if (this.ruleForm2.user !== "") {
        //   this.$refs.ruleForm2.validateField("user");
        // }
        //  this.checkuser(values => {
        //    if(values==1){
        //        callback(new Error("该用户名未注册"));
        //    }else{}
        //  })
        if (this.failinfo == 1) {
          return false;
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.failinfo == 1) {
          callback(new Error("用户名或密码错误,请检查!"));
          return false;
        } else {
          callback();
        }
      }
    };
    return {
      qqimg: require("../assets/login/qq.png"),
      qqimg1: require("../assets/login/qq1.png"),
      qqimg11: require("../assets/login/qq.png"),
      wximg: require("../assets/login/wx.png"),
      wximg1: require("../assets/login/wx1.png"),
      wximg11: require("../assets/login/wx.png"),
      weibo: require("../assets/login/weibo.png"),
      weibo1: require("../assets/login/weibo1.png"),
      weibo11: require("../assets/login/weibo.png"),

      ruleForm2: {
        user: "",
        psd: ""
      },
      rules2: {
        user: [{ validator: validatePass, trigger: "blur" }],
        psd: [{ validator: validatePass2, trigger: "blur" }]
      },
      // 控制微信二维码出现隐藏
      flag: false,
      flags: true,
      failinfo: "",
      wxcode: "",
      socketid: this.$socket.id,
      login_msg: "登录",
      domain: "",
      system:"QimMoS自动化变形监测系统",
      erroruser: "",
      errorpsd: "",
      mark: -1,
      imgs: [
        require("../assets/home/bg1.jpg"),
        require("../assets/home/bg2.jpg"),
        require("../assets/home/bg3.jpg"),
        require("../assets/home/bg4.jpg"),
        require("../assets/home/bg5.jpg"),
        require("../assets/home/bg6.jpg"),
        require("../assets/home/bg7.jpg"),
        require("../assets/home/bg8.jpg"),
        require("../assets/home/bg9.jpg"),
        require("../assets/home/bg10.jpg"),
        require("../assets/home/bg11.jpg"),
        require("../assets/home/bg12.jpg"),
        require("../assets/home/bg13.jpg"),
        require("../assets/home/bg14.jpg"),
        require("../assets/home/bg15.jpg"),
        require("../assets/home/bg16.jpg"),
        require("../assets/home/bg17.jpg"),
        require("../assets/home/bg18.jpg"),
        require("../assets/home/bg19.jpg"),
        require("../assets/home/bg20.jpg"),
        require("../assets/home/bg21.jpg"),
        require("../assets/home/bg22.jpg"),
        require("../assets/home/bg23.jpg"),
        require("../assets/home/bg24.jpg"),
        require("../assets/home/bg25.jpg"),
        require("../assets/home/bg26.jpg"),
        require("../assets/home/bg27.jpg"),
        require("../assets/home/bg28.jpg"),
        require("../assets/home/bg29.jpg")
      ],
      loginImgStyle: {
        backgroundPosition: "0px 0px",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat"
      },
      maxlogo: require("../assets/login/logo.png"),
      copyright:
        "版权所有©2020-2030  武汉岩石科技有限公司  ", 
      isHow:false,
      url: require('../assets/login/wechat.jpg'), 
      screenWidth: ((window.innerWidth - 1022) / 2 - 150)
    };
  },
  sockets: {
    //二维码
    login: function(val) {
      if (val.result.type === "fail") {
        this.$message({
          message: "该微信没有绑定账户！",
          type: "fail"
        });
        this.flag = false;
      } else {
        this.ruleForm2.user = val.result.account.data[0].username;
        this.ruleForm2.psd = val.result.account.data[0].password;
        this.submitForm("ruleForm2");
      }
      /*var that = this;
      let _windows = window;
      if (val.result.type == "success") {
        //弹出信息
        that.$message({
          message: "恭喜你,登录成功!",
          type: "success"
        });
        //微信二维码消失
        this.flag = false;
        //跳转页面
        _windows.location.href = "https://qimmos.cn/V2.0.0/";
      } else {
        that.$message({
          message: "该微信没有绑定账户！",
          type: "fail"
        });
        this.flag = false;
      }*/
    }
  },
  beforeMount() {
    this.mark = Math.floor(Math.random() * this.imgs.length);
    var that = this;
    //二级域名登录
    this.$axios
      .get("/user/get_domain_msg", {
        withCredentials: true
      })
      .then(res => {
        if (res.data.result.type == "fail") {
          console.log(res.data.result.failInfo);
        } else {
          // 获取公司的版本
          var version=res.data.domain.version
          //获取公司名字和信息
          that.domain = res.data.domain.domain;
          var name = res.data.domain.name;
          var bgimg = "https://qimmos.cn/"+version+ res.data.domain.bg_pic;
          //将登录换成公司名称
          if (res.data.domain.name == "-" || null == res.data.domain.name) {
          } else {
            that.login_msg = res.data.domain.name;
          }
          //将背景图换成公司设置的背景图
          if (res.data.domain.bg_pic == "" || null == res.data.domain.bg_pic||res.data.domain.bg_pic == "-") {
            this.play();
          } else {
            that.imgs = [];
            that.imgs.push(bgimg);
            that.mark = 0;
          }
          // 更换版权所有
          if (
            res.data.domain.copyright !== "-" &&
            null !== res.data.domain.copyright
          ) {
            this.copyright = res.data.domain.copyright;
          }
          // 更换系统名称
          if (
            res.data.domain.system !== "-" &&
            null !== res.data.domain.system
          ) {
            this.system = res.data.domain.system;
          }


          // 更换公司logo
          if (
            res.data.domain.max_logo !== "-" &&
            null !== res.data.domain.max_logo
          ) {
            this.maxlogo =
              "https://qimmos.cn/"+version+res.data.domain.max_logo;
          }
        }
      });
  },
  mounted() {
    this.showMap();
    window.onresize = () => {
      this.screenWidth =  ((window.innerWidth - 1022) / 2 - 150);
    }
  },
  created() {
    this.play();
    //监听页面的enter事件
    var that = this;
    document.onkeydown = function(e) {
      var key = window.event.keyCode;
      if (key == 13) {
        that.submitForm("ruleForm2");
      }
    };
  },
  methods: {
    //展示地图
    showMap() {
      // webgl 家庭成员   renderer渲染  mesh材质
      var camera, scene, renderer, mesh;
      var container;
      init();
      animate();
      function init() {
        container = document.getElementById("map");
        camera = new THREE.PerspectiveCamera(70, 314 / 314, 1, 215);
        camera.position.z = 215;
        scene = new THREE.Scene();
        renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
        renderer.setSize(314, 314);
        //renderer.setClearColor(0xff0000); // 设置清除色
        // renderer.setClearColor(0xff0000);
        // canvas element
        container.appendChild(renderer.domElement);
        // 点的位置，点的构成
        function latlngToXYZ(coord, radius) {
          var sphereArr = [];
          for (var i = 0; i < coord.length; i++) {
            var lat = coord[i].lat;
            var lng = coord[i].lng;
            var radLat = (lat * Math.PI) / 180;
            var radLng = (lng * Math.PI) / 180;
            var posZ = radius * Math.sin(radLat);
            var subRadius = radius * Math.cos(radLat);
            var posX = subRadius * Math.cos(radLng);
            var posY = subRadius * Math.sin(radLng);
            sphereArr.push({
              x: posX,
              y: posY,
              z: posZ
            });
          }
          return sphereArr;
        }
        var posxyz = latlngToXYZ(chinaData, 100);
        console.log(posxyz);
        var geometry = new THREE.Geometry();
        var length = posxyz.length;
        for (var i = 0; i < length; i++) {
          var vertex = new THREE.Vector3(posxyz[i].x, posxyz[i].y, posxyz[i].z);
          geometry.vertices.push(vertex);
        }
        // 表象
        var material = new THREE.PointsMaterial({ size: 0.1, color: 0xffffff });
        var partcle = new THREE.Points(geometry, material);
        scene.add(partcle);
      }
      function animate() {
        // 关键帧动画  请求运动帧
        requestAnimationFrame(animate);
        render();
        scene.rotation.x += 0.01;
        scene.rotation.y += 0.01;
      }
      function render() {
        // 关键在场景scene的设置， 相机的摆放camera
        renderer.render(scene, camera);
      }
    },
    //背景轮播图自动播放
    autoPlay() {
      this.mark = Math.floor(Math.random() * this.imgs.length);
    },
    play() {
      setInterval(this.autoPlay, 6000);
    },

    // 图片切换方法
    changeimg(index) {
      if (index == 1) {
        this.qqimg = this.qqimg1;
      } else if (index == 2) {
        this.wximg = this.wximg1;
      } else if (index == 3) {
        this.weibo = this.weibo1;
      }
    },
    moveimg(index) {
      if (index == 1) {
        this.qqimg = this.qqimg11;
      } else if (index == 2) {
        this.wximg = this.wximg11;
      } else if (index == 3) {
        this.weibo = this.weibo11;
      }
    },
    // 点击微信出现微信二维码
    wxshow() {
      this.flag = !this.flag;
      if (!this.flag) return;
      let that = this;
      this.$axios
        .get("/getQrcode", {
          params: {
            user: that.$socket.id
          },
          withCredentials: true
        })
        .then(res => {
          //复制二维码给图片
          that.wxcode = res.data;
        });
    },
    qqlogin() {
      window.location.href =
        "https://graph.qq.com/oauth2.0/authorize?response_type=token&client_id=101737521&redirect_uri=http://qimmos.cn/qqlogin&state=qqlogin";
    },

    //表单验证方法
    submitForm(formName) {
      let _windows = window;
      var that = this;
      this.$refs[formName].validate(valid => {
        let that = this;
        that.errorpsd = "";
        that.erroruser = "";
        if (valid) {
          this.$axios
            .post("/user/login", {
              username: this.ruleForm2.user,
              password: this.ruleForm2.psd
            })
            .then(res => {
              if (res.data.result.type == "fail") {
                console.log(res.data.result.failInfo);
                if (res.data.result.failInfo == "username or password") {
                  // that.$message.error("用户名或密码错误,请检查!");
                  // //清空表单的验证
                  // this.$nextTick(() => {
                  //   this.$refs["ruleForm2"].resetFields();
                  // });
                  // this.errorpsd="用户名或密码错误,请检查!"
                  this.$nextTick(() => {
                    this.errorpsd = "用户名或密码错误,请检查!";
                  });
                } else if (res.data.result.failInfo == "user not exist") {
                  //this.erroruser="用户名不存在,请检查!"
                  this.$nextTick(() => {
                    this.erroruser = "用户名不存在,请检查!";
                  });
                } else if (
                  res.data.result.failInfo == "not yet approved company"
                ) {
                  this.$nextTick(() => {
                    this.erroruser = "账户没有审批,请联系管理员审批!";
                  });
                } else if (res.data.result.failInfo == "not approved company") {
                  this.$nextTick(() => {
                    this.erroruser = "公司审批未通过,请联系管理员审批!";
                  });
                }
              } else {
                // 登录记录缓存
                  var token = res.data.result.type;
                  localStorage.setItem('token',token)

                //根据角色进入不同的服务
                let role_type = res.data.result.role;
                //公司管理员
                if (role_type === 0) {
                  _windows.location.href = "https://qimmos.cn/admin/";
                  return;
                }
                //V2.0.0授权账号
                else if (role_type === 1) {
                  _windows.location.href = "https://qimmos.cn/V2.0.0/";
                  return;
                } else {
                  // 成功后确定版本号
                  var version = res.data.result.version;
                  var domain = res.data.result.domain;
                  //判断是否存在二级域名
                  _windows.location.href = domain + "/" + version + "/";
                }
              }
            })
            .catch(function(error) {});

          // const loading = this.$loading({
          //   lock: true,
          //   text: "登录中,请稍候...",
          //   spinner: "el-icon-loading",
          //   background: "rgba(0, 0, 0, 0.7)"
          // });
          // setTimeout(() => {
          //   loading.close();
          //   this.$router.push("/admin");
          // }, 2000);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //二维码图片放大显示
    enterShow(){
      this.isHow = true;
    },
    //二维码图片放大隐藏
    enterHide(){
      setTimeout(()=>{    
        this.isHow = false;
      },100)  
    },
  }
};
</script>


// WEBPACK FOOTER //
// src/login/login.vue